const {
  VUE_APP_BASE_API,
  VUE_APP_BASE_API_JAVA,
  VUE_APP_STAR,
  VUE_APP_STAR_PLAN,
} = process.env;
const base_java_url = VUE_APP_BASE_API_JAVA || '';
const baseURL = VUE_APP_BASE_API || '';
const base_star_url = VUE_APP_STAR || '';
const base_star_plan_url = VUE_APP_STAR_PLAN || '';
export { baseURL, base_java_url, base_star_url, base_star_plan_url };
